import React, { useEffect, useState } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "./_redux/Actions";
import { FieldFeedbackLabel } from "../../../_metronic/_partials/controls/forms/FieldFeedbackLabel";
import NotificationContainer from "react-notifications/lib/NotificationContainer";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { imageUrl } from "../UIHelpers";
const getFieldCSSClasses = (touched, errors) => {
    const classes = ["form-control", "form-control-solid"];
    if (touched && errors) {
        classes.push("is-invalid-select");
    }

    if (touched && !errors) {
        classes.push("is-valid-select");
    }

    return classes.join(" ");
};

const Upload = ({
    field, // { name, value, onChange, onBlur }
    form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
    label,
    withFeedbackLabel = true,
    customFeedbackLabel,
    children,
    filter,
    ...props
}) => {

    const dispatch = useDispatch();
    const [fileData, setFileData] = useState(undefined);
    const [count, setCount] = useState(0);
    const { currentState } = useSelector(
        (state) => ({ currentState: state.upload }),
        shallowEqual
    );
    const { upload, imageField } = currentState

    const uploadImage = event => {
        if (event.target.files && event.target.files[0]) {
            if (event.target.files[0].size < process.env.REACT_APP_MAX_IMAGE_SIZE) {

                let img = event.target.files[0];
                dispatch(actions.uploadImage({ img: img, name: field.name }));
            } else {
                NotificationManager.error('File size should be less than 10mb.', 'Error');
                return;
            }
        }
    }

    useEffect(() => {
        if (imageField === field.name) {
            props.onfileValueSet(upload, imageField);
        }
    }, [upload, imageField]);

    useEffect(() => {
        setFileData(props.file);
        setCount(count + 1)
    }, [props.file]);

    return (
        <>
            <NotificationContainer />
            {label && <label className={props.isRequired ? 'required' : ''}>Upload {label}</label>}
            {fileData && fileData.default ? (
                <div className="form-group row">
                    <div className="col-lg-4">
                        <div className="thumb-image-display">
                            {/* <img alt="example" style={{ width: '100%' }} src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${fileData && fileData.default}`} /> */}
                            <img
                                alt="example"
                                style={{ width: '100%' }}
                                src={imageUrl((fileData && fileData?.default) ? fileData?.default :null)}
                                />
                            <div className="image-input-wrapper"></div>
                            <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" title="Change Image" >
                                <i className="fa fa-pen icon-sm text-muted"></i>
                                <input type="file" name="image-upload" onChange={uploadImage} accept=".png, .jpg, .jpeg" />
                            </label>
                            {/* <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="remove" title="Remove Image">
                            <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span> */}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="form-group row">
                    <div className="col-lg-4">
                        <div className="image-input image-input-empty image-input-outline" id="kt_image_5"
                            style={{ backgroundImage: `url(https://icons-for-free.com/iconfiles/png/512/box+document+outline+share+top+upload+icon-1320195323221671611.png)` }}
                        >

                            {fileData && fileData.default}
                            <div className="image-input-wrapper"></div>
                            <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" title="Change Image" >
                                <i className="fa fa-pen icon-sm text-muted"></i>
                                <input type="file" name="image-upload" onChange={uploadImage} accept=".png, .jpg, .jpeg" />
                            </label>
                            <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="remove" title="Remove Image">
                                <i className="ki ki-bold-close icon-xs text-muted"></i>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            {withFeedbackLabel && (
                <FieldFeedbackLabel
                    error={errors[field.name]}
                    touched={touched[field.name]}
                    label={label}
                    customFeedbackLabel={customFeedbackLabel}
                />
            )}
        </>
    );
}
export default Upload;